// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderContact: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 19 20" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9.5 2.063a8.312 8.312 0 1 1 0 16.624 8.312 8.312 0 0 1 0-16.624m0 17.812a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m-1.781-5.937a.595.595 0 0 0-.594.593c0 .327.267.594.594.594h3.562a.595.595 0 0 0 .594-.594.595.595 0 0 0-.594-.594h-1.187V9.782a.595.595 0 0 0-.594-.594H8.016a.595.595 0 0 0-.594.594c0 .327.267.594.594.594h.89v3.563zM9.5 7.703a.89.89 0 1 0 0-1.781.89.89 0 0 0 0 1.781"
            />
        </svg>
    );
};

export default React.memo(HeaderContact);
